import React from 'react';
import { FaTimesCircle, FaFilePdf, FaTrash } from 'react-icons/fa';

const ExtractionModal = ({
  showExtractionFiles,
  setShowExtractionFiles,
  extractionFiles,
  sections,
  removeFile
}) => {
  if (!showExtractionFiles) return null;

  // Calculate files with sections
  const filesWithSections = sections.reduce((acc, section) => {
    const file = extractionFiles.find(f => f.name === section.fileName);
    if (file && !acc.some(f => f.id === file.id)) {
      acc.push(file);
    }
    return acc;
  }, []);

  const handleRemoveFile = (id) => {
    removeFile(id, true);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-md max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Uploaded Files for Extraction
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {extractionFiles.length} PDF file{extractionFiles.length !== 1 ? 's' : ''}
            </p>
            {sections.length > 0 && (
              <p className="text-sm text-green-600 dark:text-green-400">
                {filesWithSections.length} file{filesWithSections.length !== 1 ? 's' : ''} with extraction areas
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={() => setShowExtractionFiles(false)}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <FaTimesCircle className="text-xl" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          {extractionFiles.length === 0 ? (
            <div className="text-center py-8">
              <FaFilePdf className="text-4xl text-gray-300 dark:text-gray-600 mx-auto mb-3" />
              <p className="text-gray-500 dark:text-gray-400">No files uploaded yet</p>
            </div>
          ) : (
            <div className="space-y-3">
              {extractionFiles.map((file) => {
                const hasSection = sections.some(section => section.fileName === file.name);
                return (
                  <div
                    key={file.id}
                    className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
                      hasSection
                        ? 'border-green-200 dark:border-green-700 bg-green-50 dark:bg-green-900/10 hover:bg-green-100 dark:hover:bg-green-900/20'
                        : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50'
                    }`}
                  >
                    <div className="flex items-center flex-1 min-w-0">
                      <div className={`p-2 rounded-lg mr-3 ${
                        hasSection
                          ? 'bg-green-100 dark:bg-green-900/20'
                          : 'bg-red-50 dark:bg-red-900/20'
                      }`}>
                        <FaFilePdf className={`text-lg ${
                          hasSection ? 'text-green-500' : 'text-red-500'
                        }`} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                            {file.name}
                          </p>
                          {hasSection && (
                            <span className="px-1.5 py-0.5 text-xs bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300 rounded">
                              Has section
                            </span>
                          )}
                        </div>
                        <div className="flex items-center gap-3 mt-1">
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            {file.size} MB
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            •
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            {file.uploadDate}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleRemoveFile(file.id)}
                      className="p-2 text-gray-400 hover:text-red-500 dark:hover:text-red-400 
                                 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors ml-2"
                      title="Delete file"
                    >
                      <FaTrash className="text-sm" />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="flex justify-between items-center">
            <div className="text-sm">
              <span className="text-gray-500 dark:text-gray-400">
                {extractionFiles.length} files • 
              </span>
              <span className="text-green-600 dark:text-green-400 ml-2">
                {filesWithSections.length} with sections
              </span>
            </div>
            <button
              type="button"
              onClick={() => setShowExtractionFiles(false)}
              className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 
                         bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 
                         transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtractionModal;